import axios from 'axios';

const api = axios.create({
  baseURL: 'https://us-central1-portal-monee.cloudfunctions.net/webApi/api/v1'
});

export default api; 